import React from 'react';
import { styled } from 'dripsy';
import { Platform, View } from 'react-native';
import { Observer, observer } from 'mobx-react-lite';
import { useNavigation, useRoute } from '@react-navigation/native';

import {
  AvatarImage,
  BaseMobileHeader,
  BaseText,
  IconTouchable,
  Separator,
  Touchable,
  TouchableTypeEnum,
} from '@components';
import {
  ChatNavigatorNavigationPropType,
  ChatNavigatorRoutePropType,
  screens,
} from '@navigation';
import { IS_WEB } from '@utils';
import { useChatsModel } from '@models/Chats/ChatsModel';

const RowContainer = styled(View)({
  flexDirection: 'row',
  alignItems: 'center',
});

const HeaderContainer = styled(RowContainer)({
  justifyContent: 'space-between',
});

const Title = styled(BaseText)({
  fontWeight: 'semi',
  color: '$heading800',
  variant: 'text.medium',
});

const IconLeft = styled(IconTouchable)({
  p: '$1',
});

type NavigationPropType =
  ChatNavigatorNavigationPropType<'Messaging'>;
type RoutePropType = ChatNavigatorRoutePropType<'Messaging'>;

export const MessagingHeader = observer(() => {
  const { params } = useRoute<RoutePropType>();
  const nav = useNavigation<NavigationPropType>();
  const chats = useChatsModel();
  const conversation = chats.getById(params.conversationId);

  function navigateToUser() {
    if (conversation) {
      nav.push(screens.MainNavigator, {
        screen: screens.UserProfile,
        params: { id: conversation.user.id },
      });
    }
  }

  if (IS_WEB) {
    return (
      <HeaderContainer>
        <Touchable onPress={navigateToUser}>
          <RowContainer>
            <AvatarImage
              size={52}
              source={{ uri: conversation?.user.photo.small?.url }}
            />
            <Separator vertical />
            <Title>{conversation?.user.fullName}</Title>
          </RowContainer>
        </Touchable>
      </HeaderContainer>
    );
  }

  return (
    <BaseMobileHeader
      LeftComponent={({ goBack }) => (
        <Observer>
          {() => (
            <RowContainer>
              <IconLeft
                name="small-arrow-left-light"
                onPress={goBack}
              />
              <Separator size="$7" vertical />
              <Touchable
                onPress={navigateToUser}
                type={Platform.select({
                  android: TouchableTypeEnum.WithoutFeedback,
                })}
              >
                <RowContainer>
                  <AvatarImage
                    size={52}
                    source={{
                      uri: conversation?.user.photo.small?.url,
                    }}
                  />
                  <Separator vertical />
                  <Title>{conversation?.user.fullName}</Title>
                </RowContainer>
              </Touchable>
            </RowContainer>
          )}
        </Observer>
      )}
    />
  );
});
